import cx from 'classnames';

interface TwoStepProgressBarProps {
  currentStep: 1 | 2;
}

const TwoStepProgressBar = ({ currentStep }: TwoStepProgressBarProps) => (
  <div className="flex w-full gap-1">
    <div className="schedule-meeting-progress-active h-1 flex-1 rounded-xl" />
    <div
      className={cx(
        'h-1 flex-1 rounded-xl',
        currentStep === 2 ? 'schedule-meeting-progress-active' : 'schedule-meeting-progress-inactive'
      )}
    />
  </div>
);

export default TwoStepProgressBar;
